(function(){
  var root = document.getElementById('wbh');
  if (!root) return;

  var VARIANTS = { Green: 47743783141539, Grey: 47743783174307, Pink: 47743783207075, Yellow: 47743783239843 };
  var CUTS = {
    Green: 'https://cdn.shopify.com/s/files/1/0763/1962/1283/files/bottle-green.png?v=1780664482',
    Grey:  'https://cdn.shopify.com/s/files/1/0763/1962/1283/files/wb-grey.png?v=1780666064',
    Pink:  'https://cdn.shopify.com/s/files/1/0763/1962/1283/files/wb-pink.png?v=1780666064',
    Yellow:'https://cdn.shopify.com/s/files/1/0763/1962/1283/files/wb-yellow.png?v=1780666064'
  };
  var selected = 'Green';
  var heroImg = document.getElementById('wb-hero-img');

  // Pack cards (snippets/wb-packs.liquid) drive the quantity; the savings are Shopify discounts.
  function packQty(){
    var r = root.querySelector('[data-wb-packs] input[data-wb-pack-input]:checked');
    var q = r ? parseInt(r.value, 10) : 1;
    return (q > 0 ? q : 1);
  }
  function updateAddLabel(){
    var r = root.querySelector('[data-wb-packs] input[data-wb-pack-input]:checked');
    var q = packQty();
    root.querySelectorAll('.wb-hero [data-wb-add-label]').forEach(function(l){
      l.textContent = q > 1 ? ('Add ' + q + ' to cart · ' + (r && r.dataset.total ? r.dataset.total : '')) : 'Add to Cart';
    });
  }
  root.addEventListener('change', function(e){
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-wb-pack-input')) updateAddLabel();
  });
  updateAddLabel();

  function setColour(name){
    if (!VARIANTS[name]) return;
    selected = name;
    root.querySelectorAll('.wb-sw').forEach(function(s){ s.classList.toggle('wb-on', s.dataset.colour === name); });
    var swName = document.getElementById('wb-sw-name'); if (swName) swName.textContent = name;
    root.querySelectorAll('.wb-cp-sw').forEach(function(s){ s.classList.toggle('wb-on', s.dataset.colour === name); });
    root.querySelectorAll('.wb-cp-img').forEach(function(i){ i.classList.toggle('wb-show', i.dataset.colour === name); });
    var nm = document.getElementById('wb-cp-name'); if (nm) nm.textContent = name;
    if (window.wbPacks) window.wbPacks.syncColours(root.querySelector('[data-wb-packs]'), VARIANTS[name]);
  }

  // hero swatches → set colour + swap hero to the product cut of that colour
  root.querySelectorAll('.wb-sw').forEach(function(s){
    function pick(){
      setColour(s.dataset.colour);
      if (heroImg && CUTS[s.dataset.colour]) {
        heroImg.classList.remove('wb-show');
        setTimeout(function(){ heroImg.src = CUTS[s.dataset.colour]; heroImg.classList.add('wb-show'); }, 60);
      }
    }
    s.addEventListener('click', pick);
    s.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
  });
  // colour-picker swatches
  root.querySelectorAll('.wb-cp-sw').forEach(function(s){ s.addEventListener('click', function(){ setColour(s.dataset.colour); }); });

  // toast
  var toast = document.getElementById('wb-toast'), toastMsg = document.getElementById('wb-toast-msg'), tT;
  function showToast(m){ if(!toast) return; toastMsg.textContent = m; toast.classList.add('wb-show'); clearTimeout(tT); tT = setTimeout(function(){ toast.classList.remove('wb-show'); }, 2600); }

  // add to cart → AJAX, STAY on page, fly-to-cart + live count (no redirect)
  function wbCartIcon(){
    return document.querySelector('#cart-icon, .header-actions__cart-icon, cart-icon a, cart-icon, a[href$="/cart"]');
  }
  function wbFly(srcEl){
    if (reduce || !srcEl) return;
    var target = wbCartIcon(); if (!target) return;
    var imgUrl = CUTS[selected] || (heroImg && heroImg.src); if (!imgUrl) return;
    var s = srcEl.getBoundingClientRect(), t = target.getBoundingClientRect();
    var fly = document.createElement('img');
    fly.src = imgUrl;
    fly.style.cssText = 'position:fixed;width:70px;height:70px;border-radius:16px;object-fit:contain;background:#fff;z-index:99999;pointer-events:none;box-shadow:0 14px 34px rgba(43,58,63,.28);transition:transform .8s cubic-bezier(.55,-0.25,.3,1),opacity .8s ease;left:' + (s.left + s.width / 2 - 35) + 'px;top:' + (s.top + s.height / 2 - 35) + 'px;';
    document.body.appendChild(fly);
    fly.getBoundingClientRect();
    var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
    var dy = (t.top + t.height / 2) - (s.top + s.height / 2);
    fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(8deg)';
    fly.style.opacity = '.25';
    setTimeout(function(){
      if (fly.parentNode) fly.parentNode.removeChild(fly);
      target.style.transition = 'transform .35s cubic-bezier(.2,.7,.2,1)';
      target.style.transform = 'scale(1.25)';
      setTimeout(function(){ target.style.transform = ''; }, 320);
    }, 820);
  }
  // Tell the theme about the new cart the same way its own product forms do:
  // dispatch the theme's `cart:update` event with the re-rendered cart-drawer section,
  // so the header badge updates and the drawer shows the new item. Then open the drawer.
  function wbNotifyTheme(cart, sections, variantId, qty){
    try {
      var ev = new CustomEvent('cart:update', { bubbles: true, detail: {
        resource: cart,
        sourceId: 'wb-home',
        data: { source: 'product-form-component', itemCount: qty || 1, variantId: String(variantId), productId: root.dataset.productId || '', sections: sections || {} }
      } });
      document.dispatchEvent(ev);
    } catch (err) {}
  }
  function wbOpenDrawer(){
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    return false;
  }
  var wbAdding = false;
  function addToCart(e){
    if (e && e.preventDefault) e.preventDefault();
    if (wbAdding) return; wbAdding = true;
    var id = VARIANTS[selected] || VARIANTS.Green;
    var qty = packQty();
    var packsEl = root.querySelector('[data-wb-packs]');
    var lines = (window.wbPacks && packsEl) ? window.wbPacks.getLines(packsEl, id) : [{ id: id, quantity: qty }];
    if (!lines.length) lines = [{ id: id, quantity: qty }];
    var mixed = lines.length > 1;
    var wbSrc = (e && e.currentTarget) || heroImg || root;
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function(el){ if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId); });
    showToast('Adding ' + (qty > 1 ? qty + ' ' + (mixed ? '' : selected + ' ') + 'bottles…' : selected + ' bottle…'));
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines, sections: sectionIds.join(',') })
    }).then(function(r){ return r.json(); })
      .then(function(resp){
        if (resp && resp.status) { throw new Error(resp.description || resp.message || 'add failed'); }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
          wbNotifyTheme(cart, resp && resp.sections, id, qty);
          wbFly(wbSrc);
          showToast((qty > 1 ? qty + ' ' + (mixed ? '' : selected + ' ') + 'bottles' : selected + ' bottle') + ' added to cart ✓');
          setTimeout(function(){ if (!wbOpenDrawer()) window.location.href = '/cart'; }, reduce ? 0 : 700);
          wbAdding = false;
        });
      })
      .catch(function(err){ showToast((err && err.message) ? err.message : 'Couldn’t add — please try again'); wbAdding = false; });
  }
  root.querySelectorAll('[data-wb-add]').forEach(function(b){ b.addEventListener('click', addToCart); });

  // FAQ accordion
  root.querySelectorAll('.wb-faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.closest('.wb-faq-item'), ans = item.querySelector('.wb-faq-a'), open = item.classList.contains('wb-open');
      root.querySelectorAll('.wb-faq-item').forEach(function(i){ i.classList.remove('wb-open'); i.querySelector('.wb-faq-a').style.maxHeight = null; });
      if (!open) { item.classList.add('wb-open'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
    });
  });

  // duplicate belt for seamless loop
  var belt = document.getElementById('wb-belt-track'); if (belt) belt.innerHTML += belt.innerHTML;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // scroll reveal (only when motion allowed; otherwise content stays visible)
  if (!reduce && 'IntersectionObserver' in window) {
    root.classList.add('wb-anim');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('wb-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll('.wb-reveal').forEach(function(el){ io.observe(el); });
  }

  // count-up stats
  var statsGrid = document.getElementById('wb-stats'), counted = false;
  if (statsGrid && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting && !counted) {
          counted = true;
          root.querySelectorAll('.wb-count').forEach(function(c){
            var to = parseInt(c.dataset.to, 10), dur = 1400, start = null;
            function tick(ts){ if(!start) start = ts; var p = Math.min((ts - start)/dur, 1); c.textContent = Math.round(to * (1 - Math.pow(1-p,3))); if (p < 1) requestAnimationFrame(tick); }
            if (reduce) { c.textContent = to; } else { requestAnimationFrame(tick); }
          });
        }
      });
    }, { threshold: 0.4 });
    sio.observe(statsGrid);
  }

  // parallax blobs
  var blobs = root.querySelectorAll('.wb-blob');
  if (!reduce && blobs.length) {
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      blobs.forEach(function(b){ var f = parseFloat(b.dataset.par || '0.1'); b.style.transform = 'translateY(' + (y*f) + 'px)'; });
    }, { passive: true });
  }
})();